import Vue from 'vue';
import Component from 'vue-class-component';
import {Model, Prop, Watch} from 'vue-property-decorator';
import {formatNumber} from 'wc-lib';

@Component({
  template: require('./map-box.html'),
  name: 'map-box'
})
export class MapBox extends Vue {
  @Prop()
  icon: string;

  @Prop()
  xy: Array<number>;

  @Prop()
  value: number;

  @Prop()
  label: string;

  @Prop()
  absolute: boolean;

  minWidth: number = 24;
  width = this.minWidth;
  valueWidth = 0;
  get transform() {
    return `translate(${this.xy[0]}, ${this.xy[1]})`;
  }

  get storage() {
    let value = Math.round(this.value);
    if (this.icon === 'storage' && value !== 0) {
      return value < 0 ? 'E' : 'F';
    }

    return null;
  }

  get formatedValue() {
    // BS Hide adelaide forecasts until data is fixed
    // if (this.label === 'ADELAIDE' && !this.isActual) {
    //   return 'N/A';
    // }

    let value = this.absolute ? Math.abs(Math.round(this.value)) : Math.round(this.value);
    return formatNumber(value, "0,000");
  }

  get isActual() {
    let today = new Date();
    today.setHours(0,0,0,0);
    if (this.$store.getters['app/gasDate'] < today) {
      return true;
    } else {
      return false;
    }
  }

  @Watch('value')
  valueChange() {
    this.$nextTick(function() {
      this.update();
    });
  }

  update() {
    let contentWidth = Math.max((this.$refs.label as SVGTextElement).getBBox().width, (this.$refs.valueGroup as SVGTextElement).getBBox().width + 6);
    this.width = contentWidth + 5;
    this.valueWidth = (this.$refs.value as SVGTextElement).getBBox().width;
  }

  mounted() {
    this.update();
  }
}


// WEBPACK FOOTER //
// src/components/map/map-box.ts